import _ from "lodash"
import { tryParseFloat } from "data/lib/numbers"
import { CalcStatus, getCalcStatus } from "data/interface/calc"

const sortFoldersFirst = (e, sortFn, details) => {
  sortFn(e, details).sort((a,b) => {
    const atype = _.get(a, "propertyid") ? "property" : "folder"
    const btype = _.get(b, "propertyid") ? "property" : "folder"
    let result = 0

    if(atype === btype) result = 0
    else if(atype === "folder" && btype !== "folder") result = -1
    else result = 1
    return result
  })

  return details
}

const sortName = (e, details) => {
  details.sort((a, b) => {
    const value1 = _.get(a, "name")
    const value2 = _.get(b, "name")
    let result: number | null = null

    if (!value1 && value2)
      result = -1
    else if (value1 && !value2)
      result = 1
    else if (!value1 && !value2)
      result = 0
    else
      result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0

    return (e.order * result)
  })

  return details
}

const sortCode = (e, details) => {
  details.sort((a, b) => {
    const value1 = _.get(a, "code")
    const value2 = _.get(b, "code")
    let result: number | null = null

    if (!value1 && value2)
      result = -1
    else if (value1 && !value2)
      result = 1
    else if (!value1 && !value2)
      result = 0
    else
      result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0

    return (e.order * result)
  })

  return details
}

const sortPath = (e, details) => {
  details.sort((a, b) => {
    const path1 = _.get(a, "path")
    const path2 = _.get(b, "path")
    const code1 = _.get(a, "code")
    const code2 = _.get(b, "code")
    let result: number | null = null

    if (!path1 && path2)
      result = -1
    else if (path1 && !path2)
      result = 1
    else if (!path1 && !path2)
      result = 0
    else
      result = (path1 < path2) ? -1 : (path1 > path2) ? 1 : 0

    if(result === 0) {
      if (!code1 && code2) {
        result = -1;
      } else if (code1 && !code2) {
        result = 1;
      } else if (!code1 && !code2) {
        result = 0;
      } else {
        result = (code1 < code2) ? -1 : (code1 > code2) ? 1 : 0;
      }
    }
    return (e.order * result)
  })

  return details
}

const sortValuation = (e, details) => {
  details.sort((a, b) => {
    const value1 = _.get(_.find(a.valuationdetail, 'defaultScenario'), e.field)
    const value2 = _.get(_.find(b.valuationdetail, 'defaultScenario'), e.field)
    let result: number | null = null

    if (!value1 && value2)
      result = -1
    else if (value1 && !value2)
      result = 1
    else if (!value1 && !value2)
      result = 0
    else {
      const v1 = tryParseFloat(value1)
      const v2 = tryParseFloat(value2)
      result = (v1 < v2) ? -1 : (v1 > v2) ? 1 : 0
    }

    return (e.order * result)
  })

  return details
}

const sortDate = (e, details) => {
  details.sort((a, b) => {
    const value1 = _.get(a, "activitydetail.lastupdated")
    const value2 = _.get(b, "activitydetail.lastupdated")
    let result: number | null = null

    if (!value1 && value2)
      result = -1
    else if (value1 && !value2)
      result = 1
    else if (!value1 && !value2)
      result = 0
    else
      result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0

    return (e.order * result)
  })

  return details
}

const sortUser = (e, details) => {
  details.sort((a, b) => {
    const value1 = _.get(a, "activitydetail.user")
    const value2 = _.get(b, "activitydetail.user")
    let result: number | null = null

    if (!value1 && value2)
      result = -1
    else if (value1 && !value2)
      result = 1
    else if (!value1 && !value2)
      result = 0
    else
      result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0

    return (e.order * result)
  })

  return details
}

const sortCalcStatus = (e, details) => {
  const categorize = (status) => {
    if(status === CalcStatus.CALCULATED) return 1
    else if (status === CalcStatus.CALC_WITH_ERR) return 2
    else if (status === CalcStatus.IN_PROCESS) return 3
    else if (status === CalcStatus.NOT_CALC) return 4
    else if (status === CalcStatus.WARNING) return 5
    else return 6
  }

  details.sort((a, b) => {
    const value1 = _.get(a, 'calcdetail')
    const value2 = _.get(b, 'calcdetail')
    let result: number | null = null

    if (!value1 && value2)
      result = -1
    else if (value1 && !value2)
      result = 1
    else if (!value1 && !value2)
      result = 0
    else {
      const v1 = categorize(getCalcStatus(value1))
      const v2 = categorize(getCalcStatus(value2))
      result = (v1 < v2) ? 1 : (v1 > v2) ? -1 : 0
    }

    return (e.order * result)
  })

  return details
}

const sortSearchResults = (details) => {
  details.sort((a, b) => {
    const value1 = _.get(a, "code");
    const value2 = _.get(b, "code");
    const path1 = _.get(a, "path");
    const path2 = _.get(b, "path");
    const user1 = _.get(a, "activitydetail.user");
    const user2 = _.get(b, "activitydetail.user");
    let result: number | null = null

    if (!value1 && value2) {
      result = -1;
    } else if (value1 && !value2) {
      result = 1;
    } else if (!value1 && !value2) {
      result = 0;
    } else {
      result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
    }

    if (result === 0) { // If codes are equal, compare by path
      if (!path1 && path2) {
        result = -1;
      } else if (path1 && !path2) {
        result = 1;
      } else if (!path1 && !path2) {
        result = 0;
      } else {
        const segments1 = path1.split('/');
        const segments2 = path2.split('/');
        for (let i = 0; i < Math.max(segments1.length, segments2.length); i++) {
          if(segments1.length < segments2.length) {
            result = -1;
            break;
          }
          const segment1 = segments1[i] || '';
          const segment2 = segments2[i] || '';
          if (segment1 < segment2) {
            result = -1;
            break;
          } else if (segment1 > segment2) {
            result = 1;
            break;
          }
        }
        if (result === null) {
          result = 0;
        }
      }
    }

    if (result === 0) { // If paths are equal, compare by user
      if (!user1 && user2) {
        result = -1;
      } else if (user1 && !user2) {
        result = 1;
      } else if (!user1 && !user2) {
        result = 0;
      } else {
        result = (user1 < user2) ? -1 : (user1 > user2) ? 1 : 0;
      }
    }

    return result;
  });

  return details;
}

export {sortFoldersFirst, sortName, sortCode, sortPath, sortValuation, sortDate, sortUser, sortCalcStatus, sortSearchResults}
